import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {constants} from "../constant/constant";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) {
  }

  getallDesti(): Observable<any>{
    return this.http.get<any>(constants.main_url + "/destination/getAll-active");
  }

  getallCoursesbyDesti(id): Observable<any>{
    return this.http.get<any>(constants.main_url + "/destination/courses/by-destionation/"+id);
  }
  getallUni(id): Observable<any>{
    return this.http.get<any>(constants.main_url + "/destination/univercities/by-destionation/"+id);
  }
  getallNotes(): Observable<any>{
    return this.http.get<any>(constants.main_url + "/getAll");
  }

  getallReview(): Observable<any>{
    return this.http.get<any>(constants.main_url + "/client-reviews/getAll");
  }

  addReview(req): Observable<any>{
    return this.http.post<any>(constants.main_url + "/client-reviews/saveOrEdit",req);
  }

  contact(req): Observable<any>{
    return this.http.post<any>(constants.main_url + "/util/customer/inquiry",req);
  }
}
